import API from "@/api";

export const moduleName = "dealers";

export const actionTypes = {
  ACTION_LOAD_DEALERS: "ACTION_LOAD_DEALERS",
};

export const getterTypes = {
  GETTER_DEALERS: "GETTER_DEALERS",
  GETTER_DEALERS_COUNT: 'GETTER_DEALERS_COUNT',
  GETTER_CHECKED_ROWS: 'GETTER_CHECKED_ROWS',
};

export const mutationTypes = {
  SET_DEALERS_DATA: "SET_DEALERS_DATA",
  SET_CHECKED_ROW: 'SET_CHECKED_ROW',
  SET_CHECKED_ROWS: 'SET_CHECKED_ROWS',
  UNSET_CHECKED_ROWS: 'UNSET_CHECKED_ROWS',
};

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    checkedDealerTableRows: [],
    dealers: [],
    dealersCount: 0
  }),

  actions: {
    async [actionTypes.ACTION_LOAD_DEALERS]({ commit }, payload) {
      const response = await API.dealerManager.loadDealers(payload);
      const { dealers, dealersCount } = response.data;
      commit(mutationTypes.SET_DEALERS_DATA, [dealers, dealersCount]);
    },
  },

  mutations: {
    [mutationTypes.UNSET_CHECKED_ROWS] (state) {
      state.checkedUserManagerTableRows = []
    },
    [mutationTypes.SET_DEALERS_DATA](state, [dealers, dealersCount]) {
      if (Array.isArray(dealers)) {
        state.dealers = dealers;
      }
      if (!isNaN(dealersCount)) {
        state.dealersCount = dealersCount;
      }
    },
    [mutationTypes.UNSET_CHECKED_ROWS] (state) {
      state.checkedDealerTableRows = []
    },
    [mutationTypes.SET_CHECKED_ROW] (state, row) {
      const targetIndex = state.checkedDealerTableRows.indexOf(row)
      if (targetIndex >= 0) {
        state.checkedDealerTableRows.splice(targetIndex, 1)
      } else {
        state.checkedDealerTableRows.push(row)
      }
    },

    [mutationTypes.SET_CHECKED_ROWS] (state, rows) {
      if (state.checkedDealerTableRows.length > 0 && state.checkedDealerTableRows.every(row => rows.includes(row))) {
        state.checkedDealerTableRows = []
      } else {
        state.checkedDealerTableRows = [...rows]
      }
    },
  },

  getters: {
    [getterTypes.GETTER_DEALERS]: state => state.dealers,
    [getterTypes.GETTER_DEALERS_COUNT]: (state) => state.dealersCount,
    [getterTypes.GETTER_CHECKED_ROWS]: (state) => state.checkedDealerTableRows,
  }
};
